import React from "react";

const SvgBBiconsCross = props => (
  <svg viewBox="0 0 200 200" {...props}>
    <g data-name="Obecn\xE9 ikony">
      <path d="M155 164a9 9 0 01-6.21-2.48L38.68 56.76a9 9 0 0112.41-13l110.08 104.72A9 9 0 01155 164z" />
      <path d="M44.89 164a9 9 0 01-6.21-15.52L148.76 43.72a9 9 0 1112.41 13L51.09 161.52a9 9 0 01-6.2 2.48z" />
    </g>
  </svg>
);

export default SvgBBiconsCross;

